import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  constructor(private http: HttpClient, private globalService: GlobalService) {}
  confirmContact(obj: any): Observable<any> {
    return this.globalService.post('user/contactus', obj);
  }

  getBlog(start = 0, limit = 6, search = ''): Observable<any> {
    return this.globalService.get(
      `playground/landing/blog?start=${start}&limit=${limit}&search=${search}`
    );
  }

  getSpecificBlog(title: any): Observable<any> {
    return this.globalService.get(`playground/landing/blog/${title}`);
  }

  getNews(start = 0, limit = 6, search = ''): Observable<any> {
    return this.globalService.get(
      `playground/landing/news?start=${start}&limit=${limit}&search=${search}`
    );
  }

  getSpecificNews(title: any): Observable<any> {
    return this.globalService.get(`playground/landing/news/${title}`);
  }
}
